import React, { lazy } from 'react';

// Pages
const LoginPage = lazy(() => import('../pages/LoginPage'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPasswordPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const ProfileEditPage = lazy(() => import('../pages/ProfileEditPage'));
const ProfileEditKataSandiPage = lazy(() => import('../pages/ProfileEditKataSandiPage'));
// const HomePage = lazy(() => import('../pages/HomePageStatic'));
const HomePage = lazy(() => import('../pages/HomePage'));
const PenggunaPage = lazy(() => import('../pages/PenggunaPage'));
const PenggunaTambahPage = lazy(() => import('../pages/PenggunaTambahPage'));
const PenggunaEditPage = lazy(() => import('../pages/PenggunaEditPage'));
const BesaranPajakPage = lazy(() => import('../pages/BesaranPajakPage'));
const BesaranPajakDetail = lazy(() => import('../pages/BesaranPajakDetail'));
const BesaranPajakTambahPage = lazy(() => import('../pages/BesaranPajakTambahPage'));
const BesaranPajakEditPage = lazy(() => import('../pages/BesaranPajakEditPage'));
const WajibPajakPage = lazy(() => import('../pages/WajibPajakPage'));
const WajibPajakTambahPage = lazy(() => import('../pages/WajibPajakTambahPage'));
const WajibPajakEditPage = lazy(() => import('../pages/WajibPajakEditPage'));
const TempatUsahaPage = lazy(() => import('../pages/TempatUsaha/TempatUsahaPage'));
const TempatUsahaEditOrCreatePage = lazy(() => import('../pages/TempatUsaha/TempatUsahaEditOrCreatePage'));
const TempatUsahaStarterKey = lazy(() => import('../pages/TempatUsaha/TempatUsahaStarterKey'));
const TempatUsahaStarterKeyTambah = lazy(() => import('../pages/TempatUsaha/TempatUsahaStarterKeyTambah'));
const TempatUsahaStarterKeyEdit = lazy(() => import('../pages/TempatUsaha/TempatUsahaStarterKeyEdit'));
const StarterKeyPage = lazy(() => import('../pages/StarterKeyPage'));
const GenerateStarterKeyPage = lazy(() => import('../pages/GenerateStarterKeyPage'));
const GenerateStarterKeyDetailPage = lazy(() => import('../pages/GenerateStarterKeyDetailPage'));
const GenerateStarterKeyTambahPage = lazy(() => import('../pages/GenerateStarterKeyTambahPage'));
const TransaksiPage = lazy(() => import('../pages/TransaksiPage'));
const TransaksiEditPage = lazy(() => import('../pages/TransaksiEditPage'));
const Pemetaan = lazy(() => import('../pages/Pemetaan'));
const Notifikasi = lazy(() => import('../pages/Notifikasi'));
const NotifikasiDetail = lazy(() => import('../pages/NotifikasiDetail'));
const HakAksesPage = lazy(() => import('../pages/HakAksesPage'));
const HakAksesTambahPage = lazy(() => import('../pages/HakAksesTambahPage'));
const HakAksesEditPage = lazy(() => import('../pages/HakAksesEditPage'));
const KategoriPajakTambahPage = lazy(() => import('../pages/KategoriPajakTambahPage'));
const KategoriPajakEditPage = lazy(() => import('../pages/KategoriPajakEditPage'));
const RekapitulasiPage = lazy(() => import('../pages/RekapitulasiPage'));
const AktifitasLog = lazy(() => import('../pages/AktifitasLog'));

const route = [
  // {
  //   url: '/',
  //   page: <HomePage />,
  // },
  {
    url: '/login',
    page: <LoginPage />,
  },
  {
    url: '/reset-password',
    page: <ResetPasswordPage />,
  },
  {
    url: '/',
    page: <HomePage />,
  },
  {
    url: '/profil',
    page: <ProfilePage />,
  },
  {
    url: '/profil/edit',
    page: <ProfileEditPage />,
  },
  {
    url: '/profil/gantikatasandi',
    page: <ProfileEditKataSandiPage />,
  },
  {
    url: '/pengguna',
    page: <PenggunaPage />,
  },
  {
    url: '/pengguna/create',
    page: <PenggunaTambahPage />,
  },
  {
    url: '/pengguna/:pengguna_id/edit',
    page: <PenggunaEditPage />,
  },
  {
    url: '/besaranpajak',
    page: <BesaranPajakPage />,
  },
  {
    url: '/besaranpajak/:kategori/detail',
    page: <BesaranPajakDetail />,
  },
  {
    url: '/besaranpajak/:kategori/detail/create',
    page: <BesaranPajakTambahPage />,
  },
  {
    url: '/besaranpajak/:kategori/detail/:besaran_id/edit',
    page: <BesaranPajakEditPage />,
  },
  {
    url: '/wajibpajak',
    page: <WajibPajakPage />,
  },
  {
    url: '/wajibpajak/create',
    page: <WajibPajakTambahPage />,
  },
  {
    url: '/wajibpajak/:id_wajibPajak/edit',
    page: <WajibPajakEditPage />,
  },
  {
    url: '/tempatusaha',
    page: <TempatUsahaPage />,
  },
  {
    url: '/tempatusaha/create',
    page: <TempatUsahaEditOrCreatePage />,
  },
  {
    url: '/tempatusaha/:id_tempatusaha/edit',
    page: <TempatUsahaEditOrCreatePage />,
  },
  {
    url: '/tempatusaha/:id_tempatUsaha/starterkey',
    page: <TempatUsahaStarterKey />,
  },
  {
    url: '/tempatusaha/:id_tempatUsaha/starterkey/create',
    page: <TempatUsahaStarterKeyTambah />,
  },
  {
    url: '/tempatusaha/:id_tempatUsaha/starterkey/:id_starterKey/edit',
    page: <TempatUsahaStarterKeyEdit />,
  },
  {
    url: '/starterkey',
    page: <StarterKeyPage />,
  },
  {
    url: '/generatestarterkey',
    page: <GenerateStarterKeyPage />,
  },
  {
    url: '/generatestarterkey/:id_generatestarterkey/detail',
    page: <GenerateStarterKeyDetailPage />,
  },
  {
    url: '/generatestarterkey/create',
    page: <GenerateStarterKeyTambahPage />,
  },
  {
    url: '/transaksi',
    page: <TransaksiPage />,
  },
  {
    url: '/transaksi/:id_transaksi/edit',
    page: <TransaksiEditPage />,
  },
  {
    url: '/pemetaan',
    page: <Pemetaan />,
  },
  {
    url: '/notifikasi',
    page: <Notifikasi />,
  },
  {
    url: '/notifikasi/:id_notifikasi/detail',
    page: <NotifikasiDetail />,
  },
  {
    url: '/hakakses',
    page: <HakAksesPage />,
  },
  {
    url: '/hakakses/create',
    page: <HakAksesTambahPage />,
  },
  {
    url: '/hakakses/:id_hakakses/edit',
    page: <HakAksesEditPage />,
  },
  {
    url: '/kategoripajak',
    page: <KategoriPajakTambahPage />,
  },
  {
    url: '/kategoripajak/:idkategori/edit',
    page: <KategoriPajakEditPage />,
  },
  {
    url: '/rekapitulasi',
    page: <RekapitulasiPage />,
  },
  {
    url: '/aktifitaslog',
    page: <AktifitasLog />,
  },
];

export default route;
